export const apiFake = "http://localhost:4000/";
export const api = "https://redspeedapi.redstarplc.com/api";
